<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-card :disabled="info == null" :loading="info == null">
				<v-card-text>
					<v-form v-model="valid">
						<v-row v-if="info">
							<v-col cols="12">
								عدد الرعاة: 
								<v-btn icon @click="addSponsor">
									<v-icon color="primary">mdi-cash-plus</v-icon>
								</v-btn>
								{{ info.length }}
								<v-btn icon :disabled="info.length <= 0" @click="removeSponsor(-1)">
									<v-icon color="error">mdi-cash-minus</v-icon>
								</v-btn>
							</v-col>

							<v-col v-for="(sponsor, index) in info" :key="index" cols="12">
								<v-card>
									<v-card-text>
										<v-row no-gutters>
											<v-col cols="12" md="4" order="1" order-md="2" class="pa-4">
												<v-img contain :src="sponsor.image" height="100%" max-height="250"></v-img>
											</v-col>
											<v-col cols="12" md="8" order="2" order-md="1">
												<v-row dense>
													<v-col cols="6">
														الراعي #{{ index + 1 }}:
													</v-col>
													<v-col cols="6" class="text-end">
														<v-icon color="error" @click="removeSponsor(index)">mdi-close</v-icon>
													</v-col>
													<v-col cols="12">
														<v-autocomplete v-model="sponsor.sponsor" outlined hide-details="auto" label="اختيار راعي من الشركات" :items="companies" return-object item-text="name" clearable @change="setCompanyAsSponsor(sponsor)"></v-autocomplete>
													</v-col>
													<v-col cols="12">
														<v-text-field v-model="sponsor.name" outlined hide-details="auto" label="اسم الراعي" :rules="[rules.required]"></v-text-field>
													</v-col>
													<v-col cols="12">
														<v-text-field v-model.trim="sponsor.link" outlined hide-details="auto" label="رابط الراعي" :rules="[rules.required, rules.link]" dir="ltr"></v-text-field>
													</v-col>
													<v-col cols="12">
														<v-text-field v-model.trim="sponsor.image" outlined hide-details="auto" label="رابط صورة الراعي" :rules="[rules.required, rules.link]" dir="ltr"></v-text-field>
													</v-col>
													<v-col cols="12">
														<v-text-field v-model="sponsor.type" outlined hide-details="auto" label="نوع الراعي" :rules="[rules.required]"></v-text-field>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn :loading="loading" color="primary" :disabled="!valid" @click="updateInfo">
									تحديث البيانات
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					disabled: false,
					to: { name: "dashboard-home" }
				},
				{ 
					text: "الرعاة",
					disabled: true 
				}
			],
			loading: true,
			info: null,
			valid: false,
			companies: []
		};
	},
	mounted() {
		this.getInfo();
		this.getCompanies();
	},
	methods: {
		getInfo() {
			client
				.get("/api/system/sponsors")
				.then(response => {
					this.info = response.data.data || [];
					if (this.info.length == 0) {
						this.addSponsor();
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateInfo() {
			this.loading = true;
			var data = {
				sponsors: JSON.stringify(this.info)
			};

			clientNotifier
				.post("/api/system/updateSponsors", data)
				.finally(() => {
					this.loading = false;
				});
		},
		addSponsor() {
			this.info.push({
				name: "",
				link: "",
				image: "",
				type: ""
			})
		},
		removeSponsor(index) {
			this.info.splice(index, 1);
		},
		getCompanies() {
			client
				.get("/api/companies/all")
				.then(response => {
					this.companies = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		setCompanyAsSponsor(sponsor) {
			if (sponsor.sponsor) {
				sponsor.name = sponsor.sponsor.name;
				sponsor.link = sponsor.sponsor.webLink || "";
				sponsor.image = sponsor.sponsor.logoPath;
			}
		}
	}
};
</script>